import React, { useState, createContext } from "react";
export const IframeContext = createContext({
	isInIframe: (() => {
		try {
			return window.self !== window.top;
		} catch {
			return true;
		}
	})(),
});

export const IframeProvider = ({ children }) => {
	const [isInIframe] = useState(
		(() => {
			try {
				return window.self !== window.top;
			} catch {
				return true;
			}
		})()
	);

	return (
		<IframeContext.Provider value={{ isInIframe }}>
			{children}
		</IframeContext.Provider>
	);
};
